// extracted by mini-css-extract-plugin
export default {"hr":"hr___w3Lh7Cm"};